const SET_LOGIN_SUCCESS = (state, token) => {
  state.token = token
  state.error = null
}

const SET_LOGIN_ERROR = (state, error) => {
  state.token = ''
  state.error = error
}

const SET_LOADING = (state, loading = true) => {
  state.loading = loading
}

const RESET_ERROR = (state) => {
  state.error = null
}

export default {
  SET_LOGIN_SUCCESS,
  SET_LOGIN_ERROR,
  SET_LOADING,
  RESET_ERROR
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js